import {
    CUSTOM_ROLE,
    DEFAULT_ROLES,
    RELATIONS,
    USER_RELATIONS
} from '../../app/root/constants'

const de = {
    dashboard: {
        dashboard: 'Dashboard',
        defaultViewUpdateFail:
            'Fehler beim Aktualisieren der Standard-Dashboardansicht',
        switcherHoverTooltip:
            'Legen Sie Ihre Standardansicht fest und speichern Sie sie',
        addressUpdateSuccess: 'Standortadresse erfolgreich aktualisiert',
        addressUpdateFail: 'Aktualisierung der Standortadresse fehlgeschlagen',
        mapView: 'MapView',
        reports: 'Meldungen der letzten 30 Tage',
        deviceStatusTooltipText: {
            inactive: 'Diese Geräte sind nicht im Einsatz',
            critical: 'Die Geräte müssen in Person überprüft werden.',
            info: 'Die Geräte funktionieren ordnungsgemäß.',
            warning:
                'Die WLAN-Verbindung ist möglicherweise instabil oder der Akku ist schwach'
        },
        loggedInAs: 'Angemeldet als: '
    },
    customers: {
        customer: 'Kunde',
        customers: 'Kunden',
        plan: 'Software-Plan',
        noCustomers: 'Keine Kunden vorhanden',
        noCustomer: 'Kunde wurde nicht gefunden',
        hotswapPortal: 'HotSwap Portal',
        hotswapPortalAccess: 'Zugang zum Hot-Swap-Prozess erlauben',
        hotswapUpdateService: 'Aktualisierungsdienst',
        hotswapUpdateServiceAccess: 'Erlaubt die Aktualisierungsdienst-Option',
        hotswapWelcomeEmail: 'HotSwap Willkommens-E-Mail',
        customerUsersTable: 'Tabelle der Kundennutzer',
        errorGettingUsersListForCustomer: 'Fehler beim Abrufen der Nutzerliste'
    },
    hotSwap: {
        capacityIssueMessage:
            'Liebe Kunden, aufgrund der derzeitig hohen Auslastung aufgrund von Urlaub und JERRY3 Aufträgen schalten Hotswap-Buchungen jede Woche Donnerstag um 15 Uhr aufs neue frei. Falls derzeit keine Hotswap-Buchungen möglich sind, bitten wir Sie um ein wenig Geduld. Wir aktualisieren die Kapazitäten jede Woche neu. Bei Fragen können Sie sich direkt an m.weigert@traplinked.com wenden.',
        hotSwap: 'HotSwap',
        hotSwapAdmin: 'HotSwap Admin',
        hotSwapOrders: 'HotSwap Bestellungen',
        startHotSwap: 'HotSwap starten',
        hotSwapVideoManual: 'HotSwap Videoanleitung',
        videoNotSupported: 'Ihr Browser unterstützt das Video-Tag nicht.',
        hotSwapType: 'HotSwap-Typ',
        swapReplacment: 'Geräteaustausch',
        description:
            'Einige Ihrer Geräte verbrauchen möglicherweise mehr Akku als erwartet. Um dies zu beheben, haben wir eine neue Firmware entwickelt und die alten Geräte müssen ausgetauscht werden. Auf dieser Seite können Sie den gesamten Prozess verwalten.',
        introVideo: 'Einführungsvideo',
        welcomeTitle: 'Willkommen zu unserem HotSwap Prozess',
        welcomeDesc:
            'Wir freuen uns, dass Sie dabei sind. Hier sind einige schnelle Tipps, um Ihnen den Einstieg zu erleichtern.',
        summary: {
            changeLocation: 'Standort ändern'
        },
        hotSwapTableEmptyListMessage:
            'Es tut uns leid, es gibt derzeit keine Hot-Swap-Artikel zur Anzeige. Bitte überprüfen Sie später erneut oder kontaktieren Sie den Support für Unterstützung.',
        swap_by_user: {
            label: 'Ersatzgeräte bestellen',
            title: 'Geräte selbst tauschen',
            description:
                'Wir schicken Ihnen Ersatzgeräte und Sie tauschen sie selbst aus',
            features: {
                1: 'Ersatzgeräte bestellen',
                2: 'Neue Geräte einschalten & alte Geräte ausschalten',
                3: 'Flexibel, wann immer Sie es brauchen'
            },
            stepper: {
                firstStepHeader: 'Versand planen',
                firstStepSubHeader:
                    'Wann sollen wir die Geräte geliefert werden?',
                secondStepHeader: 'Lieferadresse',
                secondStepSubHeader: 'Wohin sollen wir die Geräte liefern?',
                thirdStepHeader: 'Zusammenfassung',
                thirdStepSubHeader: 'Bestätigen Sie Ihre HotSwap-Bestellung'
            },
            btnText: 'Geräte bestellen',
            summary: {
                date: 'Lieferdatum',
                address: 'Lieferadresse'
            },
            successTitle: 'HotSwap erfolgreich geplant',
            successDesc:
                'Herzlichen Glückwunsch. Wir werden Ihre Geräte vorbereiten und pünktlich versenden.',
            footerText: 'Tracking Number:',
            trackingLink: 'Verfolgungslink:',
            detailsPageText: 'Shipping',
            termsAndConditonsLinkPart: 'Ich stimme dem HotSwap zu',
            termsAndConditonsLink: 'Allgemeine Geschäftsbedingungen',
            termsAndConditonsTextHeader: 'HotSwap Bedingungen',
            termsAndConditonsTextFirstParagraph:
                'Im Rahmen des HotSwap-Prozesses stimmen Sie folgenden Bedingungen zu.',
            termsAndConditonsTextSecondParagraph:
                "Für den Austausch von Lagergeräten legen Sie bitte einen neuen Standort in der traplinked-App an und nennen diesen ['Ihr Unternehmensname' + Hot Swap Lagerversand]. Verschieben Sie bitte alle LoRa-Geräte, die sich aktuell in Ihrem Lager befinden, in diesen neu erstellten Standort, damit die Geräte reibungslos getauscht werden können.",
            termsAndConditonsTextThirdParagraph:
                'Für den Austausch von Geräten, die sich an Kundenstandorten befinden, bitten wir Sie, die Zuordnung in der traplinked-App zu überprüfen. Falls Sie keine (Kunden-)Standorte angelegt haben oder unsere Standortfunktion nicht nutzen, weil Sie nur über die Schnittstelle von traplinked arbeiten, kontaktieren Sie uns, bevor Sie Ersatzgeräte über dieses Portal buchen.',
            termsAndConditonsTextFourthParagraph:
                'Im Rahmen des HotSwap-Prozesses stimmen Sie zu, die ausgetauschten Geräte innerhalb von 7 Tagen nach erfolgreichem Abschluss des Hot-Swap-Prozesses an uns (traplinked GmbH, Zollhof 7, 90443 Nürnberg) zurückzusenden. Wir übernehmen die Versandkosten, und das Rücksendeetikett wird Ihren Ersatzgeräten beigefügt. Sollten Verzögerungen beim Rückversand entstehen, die auf Sie zurückzuführen sind, können die zusätzlich entstehenden Kosten an Sie weitergegeben werden. Wir benötigen die ausgetauschten Geräte, um die Überarbeitung aller Systeme so schnell wie möglich zu beschleunigen.',
            termsAndConditonsTextFivethParagraph:
                'Wir stehen Ihnen während des HotSwap-Prozesses zur Verfügung und beantworten gerne alle Ihre Fragen. Vielen Dank für Ihre Zusammenarbeit und Ihr Verständnis.'
        },
        update_service: {
            label: 'Termin buchen',
            title: 'Update-Service von traplinked',
            description: 'Wir aktualisieren Ihre Geräte am aktuellen Standort',
            features: {
                1: 'Einen Termin buchen',
                2: 'Von einem traplinked-Techniker aktualisiert',
                3: 'Schnell & komfortabel'
            },
            stepper: {
                firstStepHeader: 'Update-Service buchen',
                firstStepSubHeader:
                    'Wann soll der traplinked-Techniker kommen?',
                secondStepHeader: 'Standortadresse',
                secondStepSubHeader: 'Wo ist der Standort?',
                thirdStepHeader: 'Zusammenfassung',
                thirdStepSubHeader:
                    'Bestätigung der Buchung des Update-Services'
            },
            btnText: 'Termin buchen',
            summary: {
                date: 'Datum & Uhrzeit',
                address: 'Standortadresse'
            },
            successTitle: 'Update-Service erfolgreich gebucht',
            successDesc:
                'Herzlichen Glückwunsch. Unser Techniker wird zum vereinbarten Termin am festgelegten Ort sein.',
            footerText: 'Technician:',
            detailsPageText: 'Update Service'
        },
        rememberAddress: 'Lieferadresse merken',
        saveAddress: 'Diese Adresse für den nächsten Tausch speichern.',
        backToDashboard: 'Zurück zum Dashboard',
        accordionDevicesTable: {
            exchangeDevice: 'Austauschgerät',
            connectivity: 'Konnektivität',
            hbInterval: 'HB-Intervall',
            trapSide: 'Fallen-Seite',
            wifiData: 'WIFI-Daten'
        },
        carrier: 'Transportunternehmen'
    },
    locations: {
        storageSectionTitle: 'Storage',
        storageSectionNetworkDevicesTitle: 'Netzwerk Geräte',
        storageSectionDevicesTitle: 'Geräte',
        devicesListTitle: 'Geräte',
        dragAndDropMsg: 'Ziehen Sie den Marker hierher!',
        floorPlanLoadingError:
            'Fehler beim Laden des Grundrisses. Bitte versuchen Sie es noch einmal.',
        locations: 'Standorte',
        noLocations: 'Keine Standorte vorhanden',
        searchUser: 'Benutzer suchen',
        pleaseSelectLocation: 'Bitte wählen Sie einen Standort',
        sureNotToSaveLocation:
            'Sind Sie sicher, dass Sie den neuen Standort nicht speichern möchten?',
        addSubLocation: 'Unterstandort hinzufügen',
        addDevices: 'Geräte hinzufügen',
        removeLocation: 'Standort löschen',
        devices: 'Geräte',
        network: 'Netzwerk',
        networkDevice: 'Netzwerk Gerät',
        overview: 'Übersicht',
        reports: 'Meldungen',
        stats: 'Statistiken',
        shareInfo: 'Zugriffs-Informationen',
        floorPlan: 'Grundriss',
        location: 'Standort',
        pictures: 'Bilder',
        organisation: 'Organisation',
        version: 'Version',
        status: 'Status',
        share: 'Teilen',
        batteryStatus: 'Akku-Ladestand',
        actions: 'Aktionen',
        noDevicesAdded:
            'Es wurden keine neuen Geräte zum Standort hinzugefügt.',
        devicesOnLocation: 'Geräte an diesem Standort',
        noDevicesSetupYet: 'Noch keine Geräte an diesem Standort',
        nameCanNotBeEmpty: 'Der Name darf nicht leer sein.',
        address: 'Adresse',
        parentLocation: 'Übergeordneter Standort',
        noParentLocation: 'Kein übergeordneter Standort',
        locationNotFound: 'Standort nicht gefunden',
        deviceName: 'Gerätename',
        deviceSerial: 'Seriennummer',
        event: 'Meldung',
        time: 'Zeit',
        reportsOnLocation: 'Meldungen für diesen Standort',
        noReportsOnLocation: 'Noch keine Meldungen für diesen Standort',
        locationStatistics: 'Standort-Statistiken',
        noLocationStatistics: 'Noch keine Statistiken für diesen Standort',
        locationNotShared:
            'Dieser Standort wird nicht mit anderen Benutzern geteilt.',
        sureRevokeShareAccessLocation:
            'Sind Sie sicher, dass Sie den Zugang für diesen Benutzer sperren wollen?',
        devicesAmount: 'Anzahl Geräte',
        noDevicesToAddFound: 'Es wurden keine Geräte zum Hinzufügen gefunden.',
        deleteLocationsModalText:
            'Sind Sie sicher, dass Sie diesen Standort löschen möchten? Alle untergeordneten Standorte werden ebenfalls gelöscht. Alle Geräte werden in den Speicher verschoben. Fortfahren?',
        dragNDropInfo: `Ziehen Sie Dateien hierher, oder klicken Sie, um Dateien auszuwählen.`,
        dragNDropFiles: '(Sie können png-, jpeg- und pdf-Dateien hochladen)',
        deleteFloorPlanModal:
            'Sind Sie sicher, dass Sie den Grundriss löschen wollen?',
        toDeleteFloorPlanTypeIn:
            'Bitte geben Sie diese Nummer ein, um den Grundriss zu löschen:',
        goToDevice: 'Gerät anzeigen',
        removeFromFloorPlan: 'Aus Grundriss entfernen',
        noFloorPlan: 'Für diesen Standort gibt es keinen Grundriss',
        addFloorPlan: 'Grundriss hochladen',
        addDevice: 'Gerät hinzufügen',
        addNewDevice: 'Neues Gerät hinzufügen',
        devicesInThisLocation: 'Geräte an diesem Standort',
        floorPlanBtns: {
            appearance: 'Erscheinungsbild',
            actions: 'Aktionen',
            add: 'Geräte Hinzufügen',
            allFilters: 'Filter',
            filter: 'Geräte filtern',
            delete: 'Grundriss löschen',
            replace: 'Grundriss ersetzen',
            serialLabel: 'Seriennummern',
            nameLabel: 'Gerätename'
        },
        locationsPath: 'Standortpfad',
        locationId: 'Standort-ID',
        newLocation: '- Neuer Standort -',
        responsible: 'Zuständige',
        onlyResponsibleLocations: 'Meine Standorte hervorheben',
        unlockMarkers: 'Marker lösen',
        lockMarkers: 'Marker fixieren',
        responsibleTooltip:
            'Die Standorte, für die Sie verantwortlich sind, werden mit einem kleinen blauen Punkt markiert',
        addResponsible: 'Person hinzufügen',
        add: 'Hinzufügen',
        scanWithQr: 'Scannen',
        allLocations: 'Alle',
        myLocations: 'Meine Standorte',
        userSearchError: 'Fehler bei der Benutzersuche',
        getResponsiblesError:
            'Fehler beim Laden der zuständigen Benutzer für diesen Standort',
        addResponsibleError: 'Fehler beim Hinzufügen des Zuständigen',
        deleteResponsibleError: 'Fehler beim Löschen des zuständigen Benutzers',
        getResponsibleLocationsError:
            'Fehler beim Laden von Standorten für den zuständigen Benutzer',
        userNotFound: 'Benutzer wurde nicht gefunden..',
        noLocationsForResponsible:
            'Es sind Ihnen noch keine Standorte zugewiesen.',
        assign: 'Zuweisen',
        contact: 'Ansprechpartner',
        locationEmail: 'E-mail',
        locationDetails: 'Standortdetails (optional)',
        contactPhone: 'Telefonnummer',
        noFloorplan: 'Noch kein Grundriss wurde hochgeladen.',
        selectFile:
            'Wählen Sie eine Datei aus oder legen Sie die Datei hier ab',
        uploadFloorplan: 'Grundriss hochladen',
        editFloorplan: 'Grundriss bearbeiten',
        crop: 'Zuschneiden',
        rotate: 'Drehen',
        save: 'Speichern',
        somethingWentWrong: 'Etwas schiefgegangen',
        heatmap: 'Heatmap',
        escalationLevels: 'Eskalationsstufen',
        level: 'Stufe',
        sendAutomaticallyTriggered: 'Automatisch E-Mails versenden',
        days: 'Tage',
        hours: 'Stunden',
        afterTrapStatus:
            'Nachdem die Falle ihren Status erhalten hat und sich der Status nicht geändert hat',
        afterTheTrapTriggered:
            'nachdem die Falle ausgelöst wurde und sich der Status nicht geändert hat',
        eMailOfRecipient: 'E-Mail des Empfängers',
        addLevel: 'Stufe hinzufügen',
        escalationModalSubTitle:
            'Die Nachricht wird zusammen mit den Geräteinformationen und dem Grundrissbild an die E-Mail angehängt',
        locationsWithoutAddressLabel:
            'Die folgenden Standorte haben keine Adresse, bitte speichern Sie die Adresse für diese Standorte:',
        locationsWithoutAddressAndWithoutCoordsLabel:
            'Die folgenden Standorte haben eine Adresse, können aber nicht auf der Karte angezeigt werden, da die Adresse nicht auf der Karte gefunden wurde. Bitte überprüfen Sie die Adresse des Standorts',
        floorPlanPinCaution:
            'Wir empfehlen, das Gerät neu zu starten, wenn Sie es an einen neuen Ort verschoben haben',
        showCompletedTasks: 'Abgeschlossene Aufgaben anzeigen',
        hideCompletedTasks: 'Abgeschlossene Aufgaben ausblenden',
        tasksAtThisLocation: 'Aufgaben an diesem Ort',
        createNewTask: 'Neue Aufgabe erstellen',
        tasks: 'Aufgaben',
        tasksFetchFail: 'Aufgaben konnten nicht abgerufen werden',
        taskCreated: 'Aufgabe erfolgreich erstellt',
        taskCreateFail: 'Erstellung der Aufgabe fehlgeschlagen',
        taskUpdated: 'Aufgabe erfolgreich aktualisiert',
        taskUpdateFail: 'Aktualisierung der Aufgabe fehlgeschlagen',
        taskDescriptionTooLong:
            'Die Aufgabenbeschreibung ist zu lang, maximal 1024 Zeichen erlaubt',
        includeSubLocations: 'Unter-Standorte einbeziehen',
        last30Days: 'Letzte 30 Tage',
        last7Days: 'Letzte 7 Tage',
        clickOnThePFM: 'Klicken Sie auf den Punkt für mehr Informationen',
        reportsAmount: 'Anzahl der Meldungen',
        settingsAndActions: 'Einstellungen und Aktionen',
        locationSettings: 'Standorteinstellungen',
        locationActions: 'Standortaktionen',
        baitSettings: 'Jerry Bait Einstellungen',
        successWithAmountOfUpdatedDevices:
            'Erfolg! Anzahl aktualisierter Geräte:',
        settingsAndActionsAreAppliedToAll:
            'Standortbasierte Einstellungen und Aktionen werden auf alle Geräte an diesem Standort angewendet.',
        settingsAndActionsAreNotAppliedToSL:
            'Die Einstellungen und Aktionen werden nicht auf Unterstandorte und Geräte in Unterstandorten angewendet.',
        noSettingsConfiguredYet:
            'Noch keine Einstellungen für diesen Standort konfiguriert.',
        selectSettingType: 'Einstellungstyp auswählen',
        areYouSureYouWantToRemoveThisSetting:
            'Sind Sie sicher, dass Sie diese Einstellung entfernen möchten?',
        resetTheActivityThreshold: 'Aktivitätsschwellenwert zurücksetzen',
        resetTheActivityThresholdDescr:
            'Das Zurücksetzen des Aktivitätsschwellenwerts löscht die Aktivitätsanzahl für den ausgewählten Zeitraum',
        locationBasedSettingsAndActions:
            'Standortbasierte Einstellungen und Aktionen',
        lBasedConfirmReplaceBaitQuestion:
            'Durch Bestätigen setzen Sie das Datum des letzten Ködertauschs für alle Geräte an diesem Standort.',
        lBasedConfirmThresholdResetQuestion:
            'Durch Bestätigen setzen Sie die Aktivitäten für alle Geräte an diesem Standort zurück. Ein neuer Schwellenwert wird gesetzt und die Aktivitäten werden für den ausgewählten Zeitraum zurückgesetzt.',
        lBasedSettingsAreAppliedYouCanNotEdit:
            'Die Werte für Ködergewicht und Aktivität werden vom Standort übernommen. Öffnen Sie die Standorteinstellungen, um sie zu ändern.',
        lBasedSettingsAreApplied:
            'Die Werte für Ködergewicht und Aktivität werden vom Standort übernommen.',
        confirmPowerOffDescr:
            "Hiermit bestätigen Sie, dass Sie alle Geräte an diesem Standort ausgeschaltet haben. Die Geräte bekommen den Status 'Inaktiv'",
        switchMMModeOnDescr:
            'Schaltet den Wartungsmodus für alle Geräte an diesem Standort ein. Im Wartungsmodus ändert das Gerät seinen Status nicht, es werden keine Meldungen erstellt und keine Benachrichtigungen gesendet.',
        switchMMModeOffDescr:
            'Schaltet den Wartungsmodus für alle Geräte an diesem Standort aus.',
        confirmMMModeOnDescr:
            'Der Wartungsmodus wird für alle Geräte an diesem Standort eingeschaltet. Im Wartungsmodus ändert das Gerät seinen Status nicht, es werden keine Meldungen erstellt und keine Benachrichtigungen gesendet.',
        confirmMMModeOffDescr:
            'Der Wartungsmodus wird für alle Geräte an diesem Standort ausgeschaltet.'
    },
    devices: {
        noDeviceMoveHistoryMsg: 'Keine Bewegungshistorie für dieses Gerät.',
        getDeviceMoveHistoryEx:
            'Fehler beim Laden des Gerätebewegungsverlaufs aufgetreten',
        assigned: 'Zugewiesen',
        allDevices: 'Alle Geräte',
        details: 'Gerät anzeigen',
        devices: 'Geräte',
        location: 'Standort',
        organisation: 'Organisation',
        version: 'Version',
        serialNr: 'Seriennummer',
        name: 'Name',
        deviceSerial: 'Geräteseriennummer',
        description: 'Beschreibung',
        operationModeLabel: 'Betriebsmodus',
        heartbeatCount: 'Anzahl Statusmeldungen',
        mode: 'Modus',
        status: 'Status',
        batteryStatus: 'Akku-Ladestand',
        actions: 'Aktionen',
        noDevicesSetup: 'Noch keine Geräte eingerichtet',
        noUserFromAnotherOrg:
            'Es gibt noch keinen Benutzer von einer anderen Organisation.',
        pleseAddUserFromAnotherOrg:
            'Bitte fügen Sie einen Benutzer aus einer anderen Organisation hinzu.',
        inUserMgmt: 'in der Benutzerverwaltung',
        chooseUserToShareWith:
            'Bitte wählen Sie einen Benutzer, mit dem geteilt werden soll',
        macAddress: 'MAC-Adresse',
        battery: 'Akku',
        deviceIsNotFound: 'Gerät nicht gefunden',
        nameIsTooShort: 'Der Name ist zu kurz',
        reset: 'Auf Werkseinstellungen zurücksetzen',
        resetTomStatus: 'Status zurücksetzen',
        reportCatch: 'Befall dokumentieren',
        setOffline: 'Ausschalten bestätigen',
        heartbeatInterval: 'Meldeintervall',
        occupancyRate: 'Belegungsgrad',
        triggerCount: 'Anzahl Auslösungen',
        triggeredSince: 'Seitdem ausgelöst',
        catchCount: 'Anzahl Fänge',
        traps: 'Fallen',
        noReportsNow: 'Derzeit gibt es keine Meldungen für',
        noReportsForRange: 'Für diese Zeitraum gibt es keine Meldungen für',
        noReportsYet: 'Es gibt noch keine Meldungen',
        resetDescr:
            'Die bisherige Statistik dieses Geräts wird gelöscht. Weiterhin werden folgende Einstellungen zurückgesetzt: Name, Beschreibung, Heartbeat Interval. Das Gerät bekommt den Status "Inaktiv"',
        resetDescrNote: `Beachten Sie, dass Sie den Akku separat zurücksetzen müssen.`,
        reportCatchDescr: `Sind Sie sicher, dass Sie einen Befall melden wollen?`,
        reportCatchSelectReport:
            'Für welche der folgenden Meldungen möchten Sie einen Befall dokumentieren?',
        setOfflineDescr: `Hiermit bestätigen Sie, dass sie dieses Gerät vor Ort ausgeschaltet haben. Das Gerät bekommt den Status "Inaktiv"`,
        resetBatteryDescr: `Hiermit bestätigen Sie, dass Sie die Batterien dieses Geräts vor Ort ausgewechselt haben. Der Akkustands-Zähler wird auf 100% zurückgesetzt.`,
        resetBattery: `Batteriewechsel bestätigen`,
        resetTOMStatusDescr:
            'Der Status dieses TOM-Geräts wird auf "Online" zurückgesetzt.',
        filters: {
            warning: 'Warnungen',
            info: 'Geräte online',
            inactive: 'Geräte inaktiv',
            critical: 'Kritischer Status'
        },
        online: 'Geräte online',
        stock: 'Geräte inaktiv',
        warning: 'Warnungen',
        error: 'Kritischer Status',
        qrCode: 'QR-Code',
        serialEmptyError: 'Seriennummer existiert nicht für dieses Gerät.',
        catchDescription: 'Befallsbeschreibung',
        catchDescriptionMessage:
            'Hier können Sie eine Befallsbeschreibung angeben',
        wifiSetSuccess: 'WLAN-Zugangsdaten erfolgreich gesetzt',
        wifiSetFail: 'Fehler beim Setzen der WLAN-Zugangsdaten',
        wifiSSID: 'WLAN-SSID',
        wifiPassword: 'WLAN-Passwort',
        wifiPasswordMinLengthError: 'Muss länger sein',
        wifiSSIDMinLengthError: 'Darf nicht leer sein',
        wifiSignalStrength: 'Signalstärke',
        wifiSignalStrengthHover: 'Basierend auf dem letzten Herzschlag',
        wifiExcellent: 'Sehr gut',
        wifiGood: 'Gut',
        wifiLow: 'Schwach',
        wifiBad: 'Schlecht',
        wifiUnknown: 'Unbekannt',
        operationMode: {
            movement: 'Bewegung',
            snaptrap: 'Schlagfallen',
            insect: 'Insekten',
            bait: 'Köder'
        },
        operationModeInsect: 'Insekten',
        tom: 'TOM',
        jerry: 'JERRY',
        deviceTypes: {
            tom: 'TOM',
            jerry: 'JERRY',
            'jerry-lora': 'JERRY-LoRa',
            'tm01-1': 'TrapMe',
            trapsensor: 'TrapSensor',
            'jerry-bait-rat': 'JERRY-Bait-Rat'
        },
        deviceOperationMode: 'Betriebsmodus',
        deviceType: 'Gerätetyp',
        routerType: 'Routertyp',
        insectModeTooltip: 'Dieses Gerät läuft im Insektenmodus',
        snaptrapModeTooltip: 'Dieses Gerät läuft im Schlagfallen-Modus',
        movementModeTooltip: 'Dieses Gerät läuft im Bewegungsmodus',
        baitModeTooltip: 'Dieses Gerät läuft im Ködermodus',
        rearmed: 'Gespannt',
        inactive: 'Inaktiv',
        deviceIsInactive: 'Das Gerät ist inaktiv.',
        deviceStatuses: {
            0: 'Inaktiv',
            1: 'Aktiv',
            2: 'Heartbeat ausgeblieben',
            3: 'Ausgelöst',
            4: 'Akku schwach',
            5: 'Ortungsmodus',
            6: 'Instabile Verbindung',
            7: 'Leichter Befall',
            8: 'Schwerer Befall',
            9: 'Fehlauslösung',
            10: 'Aktivität (Warnung)',
            11: 'Aktivität (Maßnahme)'
        },
        deviceStatusDescription: {
            0: 'Das Gerät ist inaktiv.',
            1: 'Das Gerät ist online und funktioniert ordnungsgemäß.',
            2: 'Das Gerät hat sich innerhalb des eingestellten Meldeintervalls nicht mehr gemeldet.',
            3: 'Eine Schlagfalle wurde ausgelöst und muss vor Ort überprüft werden.',
            4: 'Die Akkus des Geräts sind fast leer. Bitte tauschen Sie diese aus.',
            5: 'Das Gerät befindet sich im Ortungsmodus und kann geortet werden.',
            6: 'Es bestehen scheinbar Verbindungsprobleme: Die WLAN-Verbindung am Aufstellort dieses Gerätes scheint instabil zu sein.',
            7: 'Ein Nutzer hat einen leichten Befall für dieses Gerät gemeldet.',
            8: 'Ein Nutzer hat einen schweren Befall für dieses Gerät gemeldet.',
            9: 'Ein Nutzer hat eine Fehlauslösung für dieses Gerät gemeldet.',
            10: 'Ein Nutzer hat Aktivität an diesem Gerät gemeldet.',
            11: 'Ein Nutzer hat kritische Aktivität an diesem Gerät gemeldet.'
        },
        deviceStatusShortDescription: {
            0: 'Inaktiv',
            1: 'Aktiv',
            2: 'Heartbeat ausgeblieben',
            3: 'Ausgelöst',
            4: 'Akku schwach',
            5: 'Ortungsmodus',
            6: 'Instabile Verbindung',
            7: 'Leichter Befall',
            8: 'Schwerer Befall',
            9: 'Fehlauslösung',
            10: 'Aktivität (Warnung)',
            11: 'Aktivität (Maßnahme)'
        },
        deviceLastReportTypeShortDescription: {
            0: 'Online', // successfully_set_up
            1: 'Online', // restarted
            2: 'Ausgelöst',
            3: 'Online', // rearmed
            '3-bait': 'Köder vorhanden',
            4: 'Heartbeat ausgeblieben',
            5: 'Ausgefallen',
            6: 'Ortungsmodus',
            11: 'Online', // online_again
            12: 'Inaktiv',
            13: 'Instabile Verbindung',
            15: 'Leichter Befall',
            16: 'Schwerer Befall',
            17: 'Fehlauslösung',
            18: 'Aktivität (Warnung)',
            19: 'Aktivität (Maßnahme)',
            20: 'Fang',
            21: 'Aktivität erkannt',
            22: 'Aktivitätsschwelle erreicht',
            23: 'Köderstand niedrig',
            24: 'Aktivitätsschwelle erreicht und Köderstand niedrig',
            25: 'Aktivitätsschwelle zurückgesetzt'
        },
        changeOperationMode:
            'Sie haben einen anderen Modus gewählt. Damit die Änderung wirksam wird, schalten Sie ihr TOM-Gerät bitte vor Ort Aus und wieder An',
        pestControlSystemLabel: 'Fallensystem',
        pestControlSystemNotSelected: 'Nicht ausgewählt',
        pestControlSystems: {
            1: 'AF-Box (Ratte)',
            2: 'nagtag (Maus)',
            3: 'nagtag (Ratte)',
            4: 'Metalltunnel (Ratte)',
            5: 'SpeedBreak (Maus)',
            6: 'GSG (Maus)',
            7: 'Flexibles Stativ',
            8: 'Heisenberg Schabendetektor',
            9: 'Agrisense Mottentrichterfalle',
            10: 'UV-Fliegenfalle beliebig',
            11: 'GSG (Ratte)'
        },
        deviceActions: 'Geräteaktionen',
        serialNumberSearchModal: {
            header: 'Die Liste der Seriennummern suchen',
            subHeader:
                'Hier können Sie die Liste der Seriennummern der Geräte mit jeder Seriennummer in die neue Zeile wie folgt einfügen:',
            placeHolder: 'Seriennummern'
        },
        tableConfigurationModal: {
            header: 'Tabellenspalten konfigurieren',
            subHeaderMainly: 'Hauptsächlich verwendet',
            subHeaderAdditional: 'Zusätzlich'
        },
        moveDevicesModal: {
            header: {
                1: 'Wohin sollte es verschoben werden?',
                2: 'Gerät(e) an einen anderen Ort verschieben'
            },
            totalNumber: 'Gesamtanzahl:'
        },
        configureTableLabel: 'Tabelle konfigurieren',
        history: 'Verlauf',
        move: 'Bewegen',
        pestControlSystem: 'System',
        transferMode: 'Übertragungsmodus',
        cellular: 'Mobilfunk',
        connectedGateway: 'LoRa-Gateway',
        gatewayNotFound: 'Gateway nicht gefunden',
        gatewayLastSignal: 'Letztes Signal',
        notAssigned: 'Nicht zugewiesen',
        moveDToL: 'Geräte zum Standort verschieben',
        youAreNotAbleToMoveTheseDevices:
            'Sie können diese Geräte nicht verschieben, da entweder die Standorte, an denen sie sich befinden, Ihnen nicht zugewiesen sind oder Sie nur Lesezugriff darauf haben. Bitte überprüfen Sie Ihre Rolle oder wenden Sie sich an Ihren Organisationsmanager.',
        devicesAmount: 'Anzahl der Geräte',
        noDevicesYouCanMove:
            'Es gibt keine Geräte, die Sie an einen anderen Ort verschieben können',
        devicesReadyToMove: 'Diese Geräte sind bereit zum Verschieben.',
        devicesSelected: 'Ausgewählt',
        moveToLocation: 'Zum Standort verschieben',
        delete: 'Löschen',
        youAreNotAbleToDeleteTheseDevices:
            'Sie können diese Geräte nicht löschen, da entweder die Standorte, an denen sie sich befinden, Ihnen nicht zugewiesen sind oder Sie keine Löschberechtigungen dafür haben. Bitte überprüfen Sie Ihre Rolle oder wenden Sie sich an Ihren Organisationsmanager.',
        devicesRemovedFromOrg:
            'Geräte wurden erfolgreich aus der Organisation entfernt',
        deleteDevicesFromOrg: 'Geräte aus Ihrer Organisation löschen',
        noDevicesYouCanDelete: 'Es gibt keine Geräte, die Sie löschen können',
        devicesReadyToDelete: 'Diese Geräte sind bereit zum Löschen.',
        areYouSureYouWantToDeleteDevices:
            'Sind Sie sicher, dass Sie Geräte löschen möchten? Die Geräte werden aus Ihrer Organisation gelöscht und werden nicht mehr in der Geräteliste angezeigt.',
        devicesSwitchedOffSuccessfully:
            'Geräte wurden erfolgreich ausgeschaltet',
        noDevicesYouCanSwitchOff:
            'Es gibt keine Geräte, für die Sie das Ausschalten bestätigen können',
        devicesReadyToSwitchOff: 'Diese Geräte sind bereit zum Ausschalten.',
        areYouSureYouWantToConfirmSwitchOff:
            'Sind Sie sicher, dass Sie das Ausschalten dieser Geräte bestätigen möchten? Dies bestätigt, dass Sie die Geräte vor Ort ausgeschaltet haben. Die Geräte erhalten den Status "Inaktiv"',
        devicesSwitchedOnMModeSuccessfully:
            'Der Wartungsmodus wurde erfolgreich eingeschaltet',
        noDevicesYouCanSwitchOnMMode:
            'Es gibt keine Geräte, für die Sie den Wartungsmodus einschalten können',
        forTheseDevicesYouCanSwitchOnMMode:
            'Für diese Geräte können Sie den Wartungsmodus einschalten.',
        areYouSureYouWantToConfirmSwitchOnMMode:
            'Sind Sie sicher, dass Sie den Wartungsmodus für diese Geräte einschalten möchten? Im Wartungsmodus werden keine Berichte erstellt und keine Benachrichtigungen gesendet.',
        youAreNotAbleToSwitchOffTheseDevices:
            'Sie können diese Geräte nicht ausschalten, da entweder die Standorte, an denen sie sich befinden, Ihnen nicht zugewiesen sind oder Sie keine Aktualisierungsberechtigungen dafür haben. Bitte überprüfen Sie Ihre Rolle oder wenden Sie sich an Ihren Organisationsmanager.',
        youAreNotAbleToSwitchOnMModeTheseDevices:
            'Sie können den Wartungsmodus für diese Geräte nicht einschalten, da entweder die Standorte, an denen sie sich befinden, Ihnen nicht zugewiesen sind oder Sie keine Aktualisierungsberechtigungen dafür haben. Bitte überprüfen Sie Ihre Rolle oder wenden Sie sich an Ihren Organisationsmanager.',
        areYouSureConfirmReplacementOfBait:
            'Sind Sie sicher, dass Sie den Ködertausch bestätigen möchten?',
        areYouSureYouWantToResetTheActivityThreshold:
            'Sind Sie sicher, dass Sie den Aktivitätsschwellenwert zurücksetzen möchten?',
        baitMonitoring: 'Köderüberwachung',
        enablesOrDisablesBaitWeightTracking:
            'Aktiviert oder deaktiviert die Köderüberwachung',
        activityAlertThreshold: 'Aktivitätsschwellenwert',
        whenTheNotificationAlertShouldBeTriggered:
            'Bei wie vielen Aktivitäten möchten Sie eine Benachrichtigung erhalten?',
        per: 'pro',
        hours: 'Stunden',
        days: 'Tage',
        baitType: 'Ködertyp',
        whichBaitAreYouUsing: 'Welchen Köder / Gewicht nutzen Sie?',
        calibration: 'Köderschwellenwert',
        notifiedWhenBaitWeightLowerThan:
            'Auf welches Gewicht wurde das Köder Pad kalibriert? Bei diesem Restgewicht erhalten Sie eine Benachrichtigung.',
        baitPad: 'Köder Pad',
        replaceBait: 'Ködertausch durchführen',
        resetsTheBaitStatusToAvailable:
            'Setzt den Zeitpunkt des letzten Ködertauschs',
        lastReplacement: 'Letzter Ködertausch',
        baitLowCount: 'Gesamtanzahl Köderabfraß',
        activityCount: 'Gesamtanzahl Aktivitäten',
        activitiesThreshold: 'Aktivitätsschwellenwert',
        last: 'letzte',
        lastThresholdReset: 'Letztes Zurücksetzen des Aktivitätsschwellenwerts',
        activities: 'Aktivitäten',
        activitiesSummary: 'Aktivitätszusammenfassung',
        trackActivitiesInsights: 'Übersicht der Aktivitäten',
        bait: 'Köder',
        baitAvailable: 'Köder verfügbar',
        baitLow: 'Köderstand niedrig',
        baitStatusDebounceInfo:
            'Die Status „Köderstand niedrig“ und „Köder vorhanden“ werden erst aktualisiert, wenn {{minutes}} Minuten lang keine Bewegung auf dem Köder Pad erkannt wurde. Schalten Sie bei der Einrichtung des Geräts den <bold>Wartungsmodus</bold> ein, damit der Status in Echtzeit angezeigt wird.',
        manufacturerAndType: 'Hersteller / Typ',
        overrideLocationSettings:
            'Eigene Überwachungswerte für dieses Gerät verwenden',
        overrideLocationSettingsDescription:
            'Aktivieren Sie diese Option, wenn dieses Gerät andere Werte für Ködergewicht oder Aktivität benötigt als die anderen Geräte am Standort. Die Werte bleiben aktiv, bis Sie die Option ausschalten oder das Gerät zurücksetzen.',
        deviceSettingsSource: 'Verwendet Geräteeinstellungen',
        monitoringValuesSetForLocation: 'Verwendet die Einstellungen von',
        baitAndActivitySettings: 'Köder- und Aktivitätseinstellungen',
        locationSettingsOverrideMoveWarningTitle:
            'Separate Einstellungen beibehalten?',
        locationSettingsOverrideMoveWarningText:
            'Mindestens ein ausgewähltes Gerät hat eigene Einstellungen für Ködergewicht oder Aktivität. Nach dem Verschieben bleiben diese Einstellungen auf den Geräten. Die Einstellungen des neuen Standorts werden nicht übernommen.',
        locationSettingsOverrideMoveConfirm:
            'Verschieben und Einstellungen beibehalten'
    },
    simCards: {
        simCard: 'SIM-Karte',
        simCardSerialNumber: 'SIM-Kartennummer',
        activate: 'Aktivieren',
        deactivate: 'Deaktivieren',
        addSimCardLabel: 'SIM-Karte hinzufügen',
        addSimCardTooltipText:
            'Diesem Netzwerkgerät ist keine SIM-Karte zugewiesen. Sie können es manuell hinzufügen',
        simCardEmptyError: 'Darf nicht leer sein',
        simCardNotValidIccidError: 'Ungültiges SIM-Kartennummer-Format',
        pendingStatusText:
            'Der Status der SIM-Karte wird geändert, dies kann bis zu 5 Minuten dauern',
        standByStatusText:
            'Die SIM-Karte wartet auf die Datenübertragung und wird aktiv, sobald dies geschieht',
        billingDetails: {
            totalSimCardsText: 'Aktivierte Netzgeräte',
            totalSimCardsTextItalic: '(Aktueller Monat)',
            billing: 'Abrechnung',
            tooltipText:
                'Der Betrag wird am letzten Tag eines jeden Monats automatisch von Ihrem Konto abgebucht',
            currencySymbol: '€'
        }
    },
    reports: {
        sentAutomatically: 'Automatisch gesendet',
        noSharingHistory: 'Keine Freigabeverläufe vorhanden',
        sharingHistory: 'Freigabeverlauf',
        sharedBy: 'von',
        toEmails: 'An',
        ccEmails: 'CC',
        filterFrom: 'Von',
        filterTo: 'Bis',
        allReports: 'Alle Meldungen',
        reports: 'Meldungen',
        deviceName: 'Gerätename',
        deviceSerial: 'Seriennummer',
        event: 'Meldung',
        time: 'Zeitpunkt',
        location: 'Standort',
        organisation: 'Organisation',
        status: 'Status',
        type: 'Typ',
        share: 'Teilen',
        sendMessage: 'Meldung senden',
        message: 'Nachricht',
        cancle: 'Abbrechen',
        emailSentSuccess: 'Email erfolgreich versendet',
        emailSentFail: 'Ups! Irgendwas lief schief',
        send: 'Senden',
        sendReport: 'Meldung senden',
        on: ' am ',
        sentAt: 'Gesendet:',
        failToSend: 'Fehleschlagen: ',
        mailMessageBegin: 'Sehr geehrte Damen und Herren,',
        mailMessageMainSection: 'wir haben eine Auslösung der Schlagfalle ',
        mailMessageMainSection2: ' festgestellt.',
        mailMessageMainSection3:
            'Bitte überprüfen Sie zeitnah die Falle auf Fang.',
        mailMessageEnd: 'Beste Grüße ',
        mailMessageEnd2: 'FA. Fleschhut',
        noReportsYet: 'Noch keine Meldungen',
        noReportsForRange: 'Keine Meldungen für den ausgewählten Zeitraum',
        reportTime: 'Meldungszeitpunkt',
        evaluationTime: 'Bewertungszeitpunkt',
        reportTypes: {
            0: 'Konfiguriert',
            1: 'Neu gestartet',
            2: 'Ausgelöst',
            3: 'Gespannt',
            '3-bait': 'Köder vorhanden',
            4: 'Heartbeat ausgeblieben',
            5: 'Ausgefallen',
            6: 'Ortungsmodus aktiviert',
            7: 'Ortungsmodus-Fehler',
            8: 'Einstellungen geändert',
            9: 'Erfolgreiches Update',
            10: 'Akku schwach',
            11: 'Wieder online',
            12: 'Ausgeschaltet',
            13: 'Instabile Verbindung',
            14: 'Befallen',
            15: 'Leichter Befall',
            16: 'Schwerer Befall',
            17: 'Fehlauslösung',
            18: 'Aktivität (Warnung)',
            19: 'Aktivität (Maßnahme)',
            20: 'Fang',
            21: 'Aktivität erkannt',
            22: 'Aktivitätsschwelle erreicht',
            23: 'Köderstand niedrig',
            24: 'Aktivitätsschwelle erreicht und Köderstand niedrig',
            25: 'Aktivitätsschwelle zurückgesetzt'
        },
        reportTypesDescription: {
            0: 'Das Gerät wurde neu gestartet und die neuen WLAN-Daten wurden erfolgreich übertragen.',
            1: 'Das Gerät wurde neu gestartet.',
            2: 'Eine Schlagfalle wurde ausgelöst und muss vor Ort überprüft werden.',
            3: 'Schlagfallen sind gespannt und das Gerät ist bereit für den nächsten Fang.',
            '3-bait': 'Köder ist auf dem Köder Pad vorhanden.',
            4: 'Das Gerät hat sich innerhalb des eingestellten Meldeintervalls nicht mehr gemeldet.',
            5: 'Es bestehen Verbindungsprobleme: Das Gerät hat sich über längere Zeit nicht mehr gemeldet und muss vor Ort überprüft werden.',
            6: 'Das Gerät befindet sich im Ortungsmodus und kann geortet werden',
            7: 'Der Ortungsmodus konnte nicht aktiviert werden',
            8: 'Die Einstellungen des Geräts (z.B. das Meldeintervall oder/und der Betriebsmodus) wurden geändert.',
            9: 'Ein Firmware-Update für das Gerät wurde erfolgreich durchgeführt.',
            10: 'Die Akkus des Geräts sind fast leer. Bitte tauschen Sie diese aus.',
            11: 'Das Gerät hat sich wieder gemeldet, es bestehen keine Verbindungsprobleme mehr.',
            12: 'Das Gerät wurde ausgeschaltet.',
            13: 'Es bestehen scheinbar Verbindungsprobleme: Die Netzwerkverbindung am Aufstellort ist instabil.',
            14: 'Ein Nutzer hat einen Befall (Fang) für dieses Gerät gemeldet.',
            15: 'Ein Nutzer hat einen leichten Befall für dieses Gerät gemeldet.',
            16: 'Ein Nutzer hat einen schweren Befall für dieses Gerät gemeldet.',
            17: 'Für dieses Gerät wurde eine Fehlauslösung gemeldet.',
            18: 'Ein Nutzer hat Aktivität an diesem Gerät gemeldet.',
            19: 'Ein Nutzer hat kritische Aktivität an diesem Gerät gemeldet.',
            20: 'Ein Fang wurde detektiert. Manuelle Überprüfung erforderlich.',
            21: 'Eine Aktivität wurde erkannt',
            22: 'Die festgelegte Aktivitätsschwelle wurde erreicht',
            23: 'Der Köderstand ist niedrig',
            24: 'Die festgelegte Aktivitätsschwelle wurde erreicht und der Köderstand ist niedrig',
            25: 'Die Aktivitätsschwelle wurde manuell zurückgesetzt'
        },
        info: 'Info',
        warning: 'Warnung',
        critical: 'Kritisch',
        infested: 'Befallen',
        infestedDescription: 'Befallsereignisse anzeigen',
        catch: 'Fang',
        triggered: 'Ausgelöst',
        triggeredDescription: 'Ausgelöste Ereignisse anzeigen',
        connectivity: 'Konnektivität',
        connectivityDescription: 'Konnektivität pro Gerät anzeigen',
        catchDescription: 'Befallsbeschreibung',
        settings: 'Einstellungen',
        at: ' um ',
        comments: 'Kommentare',
        edit: 'Bearbeiten',
        delete: 'Löschen',
        save: 'Speichern',
        deleteConfirmation: 'Möchten Sie den Kommentar wirklich löschen?',
        addComment: '+ einen Kommentar hinzufügen',
        commentsAvailable: 'Es gibt Kommentare zu dieser Meldung',
        enterCommentPlaceholder: 'Kommentar eingeben...',
        commentEmptyEx: 'Bitte geben Sie einen Kommentar ein',
        somethingWentWrong:
            'Beim Aufnehmen von Screenshots des Grundrisses ist ein Fehler aufgetreten',
        exportDenyMsg:
            'Bitte wählen Sie für den Export einen Zeitraum von weniger als 3 Monaten. Sie können ihn in den Filtern auswählen. Der aktuelle Zeitraum ist zu groß für den Export.',
        changeRTToFT: 'Meldung zu Fehlauslösung ändern',
        changeRTToFTDescr:
            'Die Falle ist leer? Bitte fügen Sie einen Kommentar hinzu und optional ein Bild der Falle. Nach der Bestätigung wird diese Meldung zur Fehlauslösung geändert',
        changeRTToCatch: 'Meldung zu Fang ändern',
        changeRTToCatchDescr:
            'Es gibt einen Fang in der Falle? Bitte fügen Sie einen Kommentar hinzu und optional ein Bild der Falle. Nach der Bestätigung wird diese Fehlauslösung zu einem Fang geändert'
    },
    userManagement: {
        userManagement: 'Benutzerverwaltung',
        users: 'Benutzer',
        roles: 'Rolle',
        roleName: 'Rollenname',
        customer: 'Organisation',
        actions: 'Aktionen',
        createNew: 'Neu erstellen',
        addFromAnotherOrg: 'Von einer anderen Organisation hinzufügen',
        noUsersFound: 'Keine Benutzer gefunden',
        emailIsEmpty: 'E-Mail ist leer',
        isNotEmail: ' ist keine gültige E-Mail-Adresse',
        fillInEmail:
            'Bitte tragen Sie eine E-Mail-Adresse für den neuen Benutzer ein.',
        onlyToYourOrg:
            'Sie können einen Benutzer nur zu Ihrer Organisation hinzufügen',
        chooseRole: 'Bitte wählen Sie eine Rolle für den Benutzer',
        verify: 'Verifizieren',
        add: 'Hinzufügen',
        whichOrgToCreateUser:
            'Für welche Organisation möchten Sie einen Benutzer erstellen?',
        create: 'Erstellen',
        pickOrgToDeleteUser:
            'Bitte wählen Sie die Organisation, aus der Sie den Benutzer löschen möchten',
        sureDeleteUser:
            'Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?',
        sureDeleteUsers:
            'Sind Sie sicher, dass Sie diese Benutzer löschen möchten?',
        nameIsTooShort: 'Der Name ist zu kurz',
        emailIsNotCorrect: 'E-Mail ist nicht korrekt',
        genPassword: 'Passwort generieren',
        changePassword: 'Passwort ändern',
        noRolesFound: 'Es wurden keine Rollen gefunden',
        component: 'Komponente',
        read: 'Daten lesen',
        update: 'Daten aktualisieren',
        delete: 'Daten löschen',
        roleNotFound: 'Rolle wurde nicht gefunden',
        defaultRoles: {
            [DEFAULT_ROLES.traplinked_admin]: 'traplinked Administrator',
            [DEFAULT_ROLES.customer_admin]: 'Administrator',
            [DEFAULT_ROLES.viewer]: 'Beobachter',
            [DEFAULT_ROLES.management_user]: 'Manager',
            [DEFAULT_ROLES.read_only_user]: 'Betrachter',
            [DEFAULT_ROLES.location_management_user]: 'Standortverwalter',
            [DEFAULT_ROLES.technician]: 'Techniker'
        },
        youCanNotDeleteThisUser: 'Sie dürfen diesen Benutzer nicht löschen',
        youCanNotDeleteThisRole: 'Sie können diese Rolle nicht löschen',
        internalUser: 'Interner Benutzer',
        externalUser: 'Externer Benutzer',
        createUserModalTitle: 'Neuen Benutzer anlegen',
        createExternalTitle: 'Externen Benutzer erstellen',
        createInternalTitle: 'Internen Benutzer erstellen',
        userRalationStepTitle: 'Benutzerbeziehung wählen',
        credentialsStepTitle: 'Login & Passwort',
        createRoleStepTitle: 'Neue Rolle erstellen',
        selectRoleStepTitle: 'Rolle für Benutzer wählen',
        selectLocationsStepTitle: 'Standorte zuweisen',
        reviewStepTitle: 'Überprüfung',
        nextStep: 'Nächster Schritt',
        stepBack: 'Schritt zurück',
        completeBtn: 'Ok',
        backToDefaultRoles: 'Zurück zu den Standardrollen',
        userRalationOptionName: {
            [USER_RELATIONS.internal]: 'Interner Benutzer',
            [USER_RELATIONS.external]: 'Externer Benutzer'
        },
        userRalationOptionDescription: {
            [USER_RELATIONS.internal]:
                'Neues Benutzerkonto für eine Person, die in Ihrer Organisation arbeitet, geeignet für Ihren Mitarbeiter, der noch kein Konto im traplinked System hat',
            [USER_RELATIONS.external]:
                'Neues Benutzerkonto/Zugang zu Ihrer Organisation von einer externen Organisation, geeignete Auftragnehmer, die noch kein Benutzerkonto haben oder bereits eines haben'
        },
        firstName: 'Vorname',
        lastName: 'Name',
        password: 'Passwort',
        customerName: 'Name der Organisation',
        userRelationExplanation: {
            [RELATIONS.internal]:
                'Der Benutzer mit dieser E-Mail existiert bereits in Ihrer Organisation als interner',
            [RELATIONS.externalIn]:
                'Der Benutzer mit dieser E-Mail existiert bereits in Ihrer Organisation als externer',
            [RELATIONS.externalOut]:
                'Sie können diesen Benutzer nur als Externen in die Organisation aufnehmen. Möchten Sie fortfahren?',
            [RELATIONS.nonexistent]: ''
        },
        roleNames: {
            [DEFAULT_ROLES.customer_admin]: 'Administrator',
            [DEFAULT_ROLES.viewer]: 'Viewer',
            [DEFAULT_ROLES.management_user]: 'Manager',
            [DEFAULT_ROLES.technician]: 'Technician',
            [CUSTOM_ROLE]: 'Custom'
        },
        roleDescription: {
            [DEFAULT_ROLES.customer_admin]:
                'Voller Zugriff auf die Berechtigungen im System: Verwaltung von Standorten, Geräten, Benutzern und Rest',
            [DEFAULT_ROLES.viewer]:
                'Hat keinen Zugriff auf die Benutzerverwaltung, kann nur zugewiesene Standorte einsehen, den Status von Geräten sehen, Meldungen von den zugewiesenen Standorten',
            [DEFAULT_ROLES.management_user]:
                'Kann Standorte erstellen und verwalten, aber nicht löschen, kann Geräte und Meldungen verwalten, kann Benutzer verwalten, aber nicht löschen',
            [DEFAULT_ROLES.technician]:
                'Hat keinen Zugriff auf die Benutzerverwaltung, kann zugewiesene Standorte erstellen, verwalten und löschen, kann Geräte und Meldungen von zugewiesenen Standorten verwalten',
            [CUSTOM_ROLE]: 'Neue Rolle'
        },
        createNewCustomrole: '+ Erstelle eine neue Benutzerdefinierte Rolle',
        selectExistingCustomRole: 'Benutzerdefinierte Rolle auswählen',
        deselectAllLocations: 'Alle abwählen',
        selectAllLocations: 'Alle auswählen',
        showTheUserInTheList: 'in der Liste anzeigen',
        youCanProceedWithRoleSelection:
            'Sie können mit der Rollenauswahl für diesen externen Benutzer fortfahren',
        sendInvitationMail: 'Einladung per E-Mail versenden',
        invitationModalText:
            'Sind Sie sicher, dass Sie die Einladung an diesen Benutzer senden möchten?',
        usersStillAssigned: 'Gebruikers zijn nog steeds toegewezen aan die rol',
        usersAssignedTheRole:
            'Er zijn nog gebruikers toegewezen aan de rol die je wilt verwijderen',
        reassignThatUsers:
            'Wijs die gebruiker een andere rol toe voordat je deze verwijdert',
        deleteRoleConfirmation:
            'Weet je zeker dat je deze rol wilt verwijderen?',
        reassignAndDeleteModal: {
            header: 'Benutzer sind immer noch dieser Rolle zugewiesen',
            textOne:
                'Es sind immer noch Benutzer der Rolle zugewiesen, die Sie löschen möchten',
            textTwo:
                'Bitte weisen Sie diesen Benutzern eine andere Rolle zu, bevor Sie diese löschen'
        }
    },
    sharing: {
        sharing: 'Teilen',
        chooseUsers: 'Benutzer auswählen',
        chooseItems: 'Bitte auswählen, was geteilt werden soll',
        confirmAndShare: 'Bestätigen und teilen',
        organisation: 'Organisation',
        noUsersToShare:
            'Noch keine Benutzer aus einer anderen Organisation hinzugefügt',
        pleaseAddUsers:
            'Bitte fügen Sie Benutzer aus einer anderen Organisation hinzu',
        userMgmt: ' Benutzerverwaltung',
        noUsersLeft: 'Keine Benutzer mehr zur Auswahl',
        noUsersSelected: 'Noch keine Nutzer ausgewählt',
        locations: 'Standorte',
        devices: 'Geräte',
        reports: 'Meldungen',
        serialNr: 'Seriennummer',
        noDevicesToShare: 'Keine Geräte zum Teilen vorhanden',
        noDevicesLeft: 'Keine Geräte mehr zur Auswahl',
        noDevicesSelected: 'Noch keine Geräte ausgewählt',
        noReportsToShare: 'Aktuell gibt es keine Meldungen zu teilen',
        noReportsLeft: 'Keine Meldungen zur Auswahl vorhanden',
        noReportsSelected: 'Noch keine Meldungen ausgewählt',
        address: 'Adresse',
        noLocationsToShare: 'Derzeit gibt es keine Standorte zum Teilen',
        contactSupport:
            'Wenn Sie diese Nachricht sehen, wenden Sie sich bitte an den Support.',
        noLocationsLeft: 'Keine Standorte mehr zur Auswahl',
        noLocationsSelected: 'Keine Standorte ausgewählt',
        willBeSharedWith: 'Wird geteilt werden mit:',
        successShare: 'Erfolgreich geteilt'
    },
    detachedSharing: {
        noDataToShare: 'Keine Daten zum Teilen vorhanden',
        chooseUsers: 'Benutzer auswählen',
        chooseItems: 'Bitte auswählen, was geteilt werden soll',
        confirmAndShare: 'Bestätigen und teilen',
        noDevicesSetupYet: 'Noch keine Geräte an diesem Standort',
        devicesSelected: 'Ausgewählte Geräte',
        locationsSelected: 'Ausgewählte Standorte',
        selected: 'Ausgewählt',
        shareWithUsers: 'Teilen mit Benutzern',
        existingFromAnotherOrg:
            'die von einer anderen Organisation hinzugefügt wurden',
        byEmailFromAnotherOrg: 'per E-Mail',
        noUsersToShare:
            'Noch keine Benutzer aus einer anderen Organisation hinzugefügt. Sie können per E-Mail teilen.',
        usersSelected: 'Ausgewählte Benutzer',
        plsTypeInEmail: 'Bitte geben Sie eine gültige E-Mail Adresse ein',
        chooseRole: 'Bitte wählen Sie eine Rolle',
        addUsersEmails: 'E-Mail-Adressen der Benutzer hinzufügen',
        location: 'Standort',
        device: 'Gerät',
        serialNr: 'Seriennummer',
        dataForSharing: 'Daten zum Teilen',
        willBeSharedWith: 'Wird geteilt werden mit',
        locationsPath: 'Standortpfad',
        nothingFound: 'Nichts gefunden'
    },
    settings: {
        faq: 'FAQ',
        language: 'Sprache',
        settings: 'Einstellungen',
        logout: 'Ausloggen',
        emailNotificationsEnabled: 'E-Mail-Benachrichtigungen aktiviert',
        pushNotificationsEnabled: 'Push-Benachrichtigungen aktiviert',
        smsNotificationsEnabled: 'SMS-Benachrichtigungen aktiviert',
        trapsTriggeredNotificationsEnabled: 'Gerät hat ausgelöst',
        trapsInactiveemailNotificationsEnabled: 'Gerät ist ausgefallen',
        batteryEmptyNotificationsEnabled: 'Gerät hat schwachen Akku',
        batterySetupNotificationsEnabled: 'Gerät erfolgreich konfiguriert',
        trapOnlineNotificationsEnabled: 'Gerät wieder online',
        unstableConnectionNotificationsEnabled:
            'Gerät hat instabile Verbindung',
        baitLowNotificationsEnabled: 'Gerät hat niedrigen Köderstand',
        activityThresholdReachedNotificationsEnabled:
            'Gerät hat Aktivitätsschwellenwert erreicht',
        baitLowAndActivityThresholdReachedNotificationsEnabled:
            'Gerät hat niedrigen Köderstand und hat Aktivitätsschwellenwert erreicht',
        acceptSharedData: 'Geteilte Daten aktualisieren',
        notificationsChannels: 'Benachrichtigungskanäle',
        notificationsEvents: 'Benachrichtigungen',
        nameIsTooShort: 'Der Name ist zu kurz',
        phoneNumberErr: 'Telefonnummer ist ungültig',
        organisationPhoneNumberErr:
            'Die Telefonnummer der Organisation ist ungültig',
        reportBug: 'Einen Fehler melden',
        viewOurRoadmap: 'Roadmap',
        voteOnNewFeatures: 'Über neue Funktionen abstimmen',
        termsOfService: 'AGB',
        termsConditions: 'Bedingungen und Konditionen',
        privacyPolicy: 'Datenschutzrichtlinie',
        simCards: 'SIM-Karten',
        billingPortal: 'Abrechnung',
        portalError: 'Fehler beim Laden des Stripe-Abrechnungsportals'
    },
    login: {
        emailIsRequired:
            'Für die Anmeldung ist eine E-Mail-Adresse erforderlich',
        passwordIsRequired: 'Für die Anmeldung ist ein Passwort erforderlich',
        forgotPassword: 'Passwort vergessen?',
        signIn: 'Einloggen',
        newInTraplinked: 'Neuer Kunde? Hier können Sie sich registrieren.'
    },
    twoFactor: {
        title: 'Zwei-Faktor-Authentifizierung',
        helperText:
            'Geben Sie den 6-stelligen Code ein, den wir an Ihre E-Mail gesendet haben',
        verify: 'Bestätigen',
        backToLogin: 'Zurück zur Anmeldung'
    },
    resetPassword: {
        resetPassword: 'Passwort zurücksetzen',
        backToLogin: 'Zurück zur Anmeldeseite',
        goToLogin: 'Zur Anmeldeseite',
        passwordIsTooShort: 'Das Passwort ist zu kurz',
        passwordsDoNotMatch: 'Passwörter stimmen nicht überein'
    },
    register: {
        nameIsTooShort: 'Der Name ist zu kurz.',
        emailIsNotCorrect: 'E-Mail-Adresse ist nicht korrekt',
        passwordIsTooShort: 'Das Passwort ist zu kurz',
        passwordsDoNotMatch: 'Die Passwörter stimmen nicht überein',
        registerUser: 'Benutzer registrieren',
        haveAlreadyUser: 'Haben Sie bereits ein Benutzerkonto? Hier einloggen.',
        pleaseEnterOrgName: 'Bitte geben Sie den Namen Ihrer Organisation ein.',
        orgName: 'Name der Organisation',
        registerOrg: 'Organisation erstellen',
        everythingIsReady:
            'Ihr Benutzerkonto wurde erfolgreich erstellt. Melden Sie sich nun an.',
        goToLogin: 'Zur Anmeldeseite gehen',

        registerYourOrganization: 'Registrieren Sie Ihre Organisation',
        youAreAPestController:
            'Sie sind ein Schädlingsbekämpfer und möchten Ihre Organisation registrieren',
        alreadyHaveAnAccount: 'Sie haben bereits ein Konto?',
        login: 'Einloggen',
        or: 'Oder',
        joinAnExistingOrganization: 'Einer bestehenden Organisation beitreten?',
        accessYourOrganization:
            'Wenn Sie ein Techniker oder ein Teammitglied sind und auf Ihre Organisation zugreifen möchten, bitten Sie Ihren Administrator, Sie einzuladen.',
        notSureWhoYourAdmin:
            'Sie sind sich nicht sicher, wer Ihr Administrator ist oder haben Probleme? Kontaktieren Sie unser Support-Team für Hilfe.'
    },
    apiKeys: {
        apiKeys: 'API-Schlüssel',
        apiKey: 'API-Schlüssel',
        viewDocs: 'REST-Dokumentation öffnen',
        copied: 'Kopiert',
        failedToCopy: 'Fehler beim Kopieren',
        createNew: 'Neu erstellen',
        expires: 'Gültig bis',
        noApiKeysFound: 'Es wurden keine API-Schlüssel gefunden',
        plsProvideDescr:
            'Geben Sie bei der Beschreibung z. B. den Namen der Software ein, bei der Sie den API-Schlüssel eintragen.',
        deleteKeyDescr:
            'Wenn Sie diesen API-Schlüssel löschen, ist der Zugriff auf die Daten über diesen API-Schlüssel nicht mehr möglich. Sind Sie sicher, dass Sie diesen API-Schlüssel löschen möchten?',
        viewKeyDescr:
            'Geben Sie den API-Schlüssel in der Software ein, damit diese Ihre Gerätedaten anzeigen kann. Wenn der Hersteller eine entsprechende Funktion anbietet, können Sie auch den QR-Code scannen, um den API-Schlüssel einzugeben.'
    },
    integrations: {
        integrations: 'Integrationen',
        documentationTools: 'Dokumentationstools',
        apiKeys: 'API-Schlüssel',
        pestsoft: 'Pestsoft',
        debuxx: 'DEBUXX',
        pestscan: 'Pestscan',
        pestscanPcoId: 'Pestscan PCO ID',
        username: 'Benutzername',
        enterPassword: 'Passwort eingeben',
        credentialsRequired:
            'Geben Sie die Anmeldedaten ein und speichern Sie diese, um die Verbindung abzuschließen.',
        pestscanPcoIdRequiredWhenEnabled:
            'Die PCO ID ist erforderlich, wenn Pestscan aktiviert ist.',
        debuxxHint: {
            toggle: 'Wie erhalte ich die Zugangsdaten?',
            title: 'DEBUXX-API-Benutzer anlegen',
            body: 'Administratoren können in DEBUXX unter **Einstellungen → Erweiterungen** einen neuen API-Benutzer selbstständig anlegen, indem sie einen Benutzernamen und ein Passwort vergeben. Übertragen Sie diese Werte anschließend hierher.',
            support:
                'Sie brauchen weitere Hilfe? Wenden Sie sich an den DEBUXX-Support, wenn Sie weitere Fragen zur Erstellung der Zugangsdaten haben.'
        },
        pestscanHint: {
            toggle: 'Wie erhalte ich meine PCO-ID?',
            title: 'PC40-Profil in Pestscan anlegen',
            steps: {
                1: 'Öffnen Sie über das Zahnrad in der Hauptnavigation die **Allgemeinen Einstellungen**.',
                2: 'Wählen Sie im Menü **Dauerüberwachung**.',
                3: 'Öffnen Sie den Reiter **Profile** und klicken Sie auf **Neu**.',
                4: 'Setzen Sie **Beschreibung** auf einen aussagekräftigen Wert, z. B. PC40.',
                5: 'Setzen Sie **Typ** auf PC40.',
                6: 'Klicken Sie auf **Speichern**.',
                7: 'Kopieren Sie die angezeigte **PCO-ID** und fügen Sie sie hier ein.'
            },
            support:
                'Sie brauchen weitere Hilfe? Wenden Sie sich an den Pestscan-Support, wenn Sie weitere Fragen zur PCO-ID haben.'
        },
        settingsUpdated: 'Integrationseinstellungen aktualisiert',
        settingsUpdateFailed:
            'Fehler beim Aktualisieren der Integrationseinstellungen',
        loadFailed: 'Fehler beim Laden der Integrationseinstellungen',
        summaryTitle: 'Übersicht Integrationen & API',
        apiKeysCount: 'API-Schlüssel',
        webhooks: 'Webhooks',
        webhooksTab: {
            title: 'Webhooks',
            viewDocs: 'Webhook-Dokumentation öffnen',
            createWebhook: 'Webhook erstellen',
            editWebhook: 'Webhook bearbeiten',
            deleteWebhook: 'Webhook löschen',
            confirmDeleteWebhook:
                'Der Webhook wird dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
            noWebhooksFound: 'Noch keine Webhooks',
            emptyBody:
                'Webhooks liefern Geräte-Meldungen in Echtzeit an Ihre Endpunkte. Erstellen Sie einen, um Daten zu erhalten.',
            editorSubtitle: 'Webhooks liefern Geräte-Meldungen in Echtzeit',
            webhookCreated: 'Webhook erstellt',
            webhookUpdated: 'Webhook aktualisiert',
            webhookDeleted: 'Webhook gelöscht',
            createFailed: 'Webhook konnte nicht erstellt werden',
            updateFailed: 'Webhook konnte nicht aktualisiert werden',
            deleteFailed: 'Webhook konnte nicht gelöscht werden',
            loadFailed: 'Webhooks konnten nicht geladen werden',
            statusEnabled: 'Aktiv',
            statusDisabled: 'Inaktiv',
            saveChanges: 'Änderungen speichern',
            cancel: 'Abbrechen',
            never: '--',
            fields: {
                status: 'Status',
                name: 'Name',
                description: 'Beschreibung',
                endpoint: 'URL',
                webhookType: 'Typ',
                requestMethod: 'Methode',
                reasons: 'Meldungstypen',
                reasonSingular: 'Meldungstyp',
                reasonPlural: 'Meldungstypen',
                reasonsTotalSuffix: 'verfügbar',
                isEnabled: 'Aktiviert',
                isEnabledHint:
                    'Wenn aktiv, werden Meldungen zu den ausgewählten Meldungstypen zugestellt.',
                headers: 'Header',
                lastResponse: 'Letzte Antwort',
                lastResponseCode: 'Letzter Antwortcode',
                lastRequestTimestamp: 'Letzte Anfrage'
            },
            placeholders: {
                name: 'Mein Webhook',
                endpoint: 'https://example.com/webhooks/traplinked',
                description: 'Wofür ist dieser Webhook?',
                reasonsEmpty: 'Einen oder mehrere Meldungstypen wählen…'
            },
            headers: {
                keyHeader: 'Schlüssel',
                valueHeader: 'Wert',
                keyPlaceholder: 'z. B. Authorization',
                valuePlaceholder: 'Wert',
                addRow: 'Header hinzufügen',
                removeRow: 'Header entfernen',
                maskedHint: '•••••• Zum Überschreiben erneut eingeben',
                renamedHint: 'Umbenannt — Wert erneut eingeben',
                versionRequired: 'Erforderlich',
                versionLatestHint: 'neueste ist',
                versionLatestSuffix: 'neueste',
                empty: 'Noch keine eigenen Header. Fügen Sie einen hinzu, um Ihre Anfragen zu authentifizieren.'
            },
            validation: {
                nameRequired: 'Name ist erforderlich',
                endpointRequired: 'URL ist erforderlich',
                reasonsRequired: 'Wählen Sie mindestens einen Meldungstyp aus',
                headerKeyRequired: 'Header-Schlüssel ist erforderlich',
                headerValueRequired: 'Header-Wert ist erforderlich',
                headerKeyDuplicate: 'Header-Schlüssel müssen eindeutig sein',
                versionReserved:
                    'traplinked-Version wird oben gesetzt, nicht als eigener Header'
            },
            reasonGroupLabels: {
                device: 'Gerätestatus',
                trap: 'Fallen-Meldungen',
                image: 'Bilder',
                heartbeat: 'Heartbeat',
                activity: 'Aktivität & Köder'
            },
            reasonLabels: {
                image_received: 'Bild empfangen',
                image_ai_processed: 'Bild von KI verarbeitet',
                heartbeat_received: 'Heartbeat empfangen',
                trap_triggered: 'Falle ausgelöst',
                battery_low: 'Akku schwach',
                catch_detected: 'Fang erkannt',
                rearmed: 'Gespannt',
                offline: 'Offline',
                online: 'Online',
                configured: 'Konfiguriert (Initiale Fabrik-Einrichtung)',
                maintained: 'Gewartet (Nach Fabrik-Wartung)',
                switched_off: 'Ausgeschaltet',
                catch_reported: 'Fang gemeldet',
                false_triggering: 'Fehlauslösung',
                activity_noticed: 'Aktivität erkannt',
                activity_threshold_reached: 'Aktivitätsschwelle erreicht',
                bait_low: 'Köderstand niedrig',
                activity_threshold_reached_and_bait_low:
                    'Aktivitätsschwelle erreicht und Köderstand niedrig'
            },
            typeLabels: {
                traplinked: 'traplinked',
                rentokil_tom_images: 'Rentokil TOM-Bilder',
                pestsoft: 'Pestsoft',
                axinsectai: 'AxInsectAI'
            },
            methodLabels: {
                post: 'POST',
                put: 'PUT',
                patch: 'PATCH',
                get: 'GET',
                delete: 'DELETE'
            }
        },
        billingNotice:
            'Aktive Integrationen und API-Schlüssel kosten 0,10 € pro Gerät und Monat für Geräte, die seit Monatsbeginn mindestens einmal ein Signal gesendet haben. Geräte, die am oder vor dem 31.12.2024 erstellt wurden, sind ausgenommen.',
        openBillingDashboard: 'Abrechnungs-Dashboard öffnen',
        billingDataLoadFailed:
            'Fehler beim Laden der Integrations- und Abrechnungsübersicht',
        billingModalTitle:
            'Diese Aktivierung wirkt sich auf Ihre Abrechnung aus',
        billingModalIntro:
            'Das Aktivieren einer Integration, eines API-Schlüssels oder eines Webhooks startet die Abrechnung für Ihre Organisation. Details:',
        billingModalRulePrice: 'Kosten: 0,10€ pro Gerät und Monat',
        billingModalRuleHeartbeat:
            'Berechnet werden nur Geräte, die innerhalb eines Monats mindestens ein Signal (Heartbeat) gesendet haben',
        billingModalRuleGrandfathered:
            'Für Geräte, die seit oder vor dem 31.12.2024 online sind, entstehen keine Kosten',
        billingModalConfirm: 'Kostenpflichtig aktivieren',
        billingModalCancel: 'Abbrechen'
    },
    sagasMsgs: {
        /* common */
        getReportSharingHistoryEx: 'Fehler beim Abrufen der Meldungen',
        commonLoadingError:
            'Etwas schiefgegangen. Bitte versuch es noch einmal',
        /* login */
        loginEx: 'Die Anmeldedaten sind nicht korrekt.',
        loginWithTsEx:
            'Es ist ein Fehler aufgetreten, bitte kontaktieren Sie den Support.',
        sessionEx: 'Ihre Sitzung ist abgelaufen',
        verify2faEx:
            'Ungültiger oder abgelaufener Code. Bitte versuchen Sie es erneut.',
        updataProfileRes: 'Das Profil wurde aktualisiert.',
        updataProfileEx: 'Fehler beim Aktualisieren des Profils',
        pswdChangeRes: 'Das Passwort wurde geändert.',
        pswdChangeEx:
            'Fehler beim Ändern des Passworts. Stellen Sie sicher, dass das alte Passwort korrekt ist.',
        forgotPswdRes:
            'Ein Link zum Zurücksetzen Ihres Passworts wurde an Ihre E-Mail-Adresse versendet.',
        forgotPswdEx: 'Fehler beim Anfordern der Passwortrücksetzung',
        resetPswdRes:
            'Das Passwort wurde erfolgreich geändert. Sie können sich nun anmelden.',
        resetPswdEx:
            'Es ist ein Fehler aufgetreten. Bitte versuchen Sie erneut, das Passwort auf der Anmeldeseite zurückzusetzen.',
        saveLocaleEx: 'Fehler beim Speichern der Spracheinstellung',
        /* customers */
        getCustomersEx: 'Fehler beim Laden der Kunden',
        getCustomerEx: 'Fehler beim Laden des Kunden',
        updateCustomerEx: 'Fehler beim Aktualisieren des Kunden',
        updateCustomerRes: 'Der Kunde wurde erfolgreich aktualisiert.',
        getSoftwarePlansEx: 'Fehler beim Laden der Softwarepläne',
        /* locations */
        getLocationsEx: 'Fehler beim Laden der Standorte',
        getLocationEx: 'Fehler beim Laden des Standorts',
        updateLocationRes: 'Der Standort wurde erfolgreich aktualisiert.',
        updateLocationEx: 'Fehler beim Aktualisieren des Standorts',
        createLocationRes: 'Der Standort wurde erfolgreich erstellt.',
        createLocationEx: 'Fehler beim Erstellen des Standorts',
        deleteLocationRes: 'Der Standort wurde erfolgreich gelöscht.',
        deleteLocationEx: 'Fehler beim Löschen des Standorts',
        shareLocationRes: 'Erfolgreich geteilt',
        shareLocationEx: 'Fehler beim Teilen',
        getLocationDevicesEx: 'Fehler beim Laden der Geräte',
        getLocationReportsEx: 'Fehler beim Laden der Meldungen',
        getLocationSharedUsersEx: 'Fehler beim Laden der Zugriffsinformationen',
        getAvailableDevicesEx: 'Fehler beim Laden der Geräte',
        moveDevicesRes:
            'Die Geräte wurden erfolgreich zum Standort hinzugefügt',
        moveDevicesEx: 'Fehler beim Hinzufügen von Geräten zum Standort',
        createFloorPlanRes: 'Der Grundriss wurde erfolgreich erstellt',
        createFloorPlanEx: 'Fehler beim Erstellen des Grundrisses',
        getFloorPlanEx: 'Fehler beim Laden des Grundrisses',
        deleteFloorPlanRes: 'Der Grundriss wurde erfolgreich gelöscht',
        deleteFloorPlanEx: 'Fehler beim Löschen des Grundrisses',
        getFPAvailableDevicesEx: 'Fehler beim Laden der Geräte',
        addDevicesToFPEx: 'Fehler beim Hinzufügen von Geräten zum Grundriss',
        updateFPDeviceEx: 'Fehler beim Aktualisieren des Geräts',
        deleteFPDeviceEx: 'Fehler beim Löschen des Geräts',
        /* devices */
        getDevicesEx: 'Fehler beim Laden der Geräte',
        getDeviceEx: 'Fehler beim Laden des Geräts',
        getDeviceReportsEx: 'Fehler beim Laden der Meldungen',
        shareDevicesRes: 'Erfolgreich geteilt',
        shareDevicesEx: 'Fehler beim Teilen',
        resetDeviceRes: 'Das Gerät wurde zurückgesetzt.',
        resetDeviceEx: 'Fehler beim Zurücksetzen des Geräts',
        reportCatchRes: 'Der Befall wurde erfolgreich gemeldet.',
        reportCatchEx: 'Fehler beim Melden des Befalls',
        setOfflineRes: 'Das Gerät wurde ausgeschaltet.',
        setOfflineEx: 'Fehler beim Ausschalten des Gerätes',
        batteryResetRes: 'Die Batterie wurde zurückgesetzt.',
        batteryResetEx: 'Fehler beim Zurücksetzen der Batterie',
        updateDeviceRes: 'Das Gerät wurde aktualisiert.',
        updateDeviceEx: 'Fehler beim Aktualisieren des Geräts',
        getPestControlSystems: 'Fehler beim Laden von Fallensystemen',
        tomStatusResetRes: 'Status wurde zurückgesetzt',
        tomStatusResetEx: 'Fehler beim Zurücksetzen des Status',
        /* reports */
        getReportsEx: 'Fehler beim Laden der Meldungen',
        getReportEx: 'Fehler beim Laden der Meldung',
        getLastReportDateEx:
            'Beim Laden des Datums des letzten Berichts ist ein Fehler aufgetreten',
        /* user mgmt */
        getUsersEx: 'Fehler beim Laden der Benutzer',
        getUserEx: 'Fehler beim Laden des Benutzers',
        getRoleEx: 'Fehler beim Laden der Rolle',
        createRoleRes: 'Die Rolle wurde erfolgreich erstellt.',
        createRoleEx: 'Fehler beim Erstellen der Rolle',
        updateRoleRes: 'Die Rolle wurde erfolgreich aktualisiert.',
        updateRoleEx: 'Fehler beim Aktualisieren der Rolle',
        getRolesEx: 'Fehler beim Laden der Rollen',
        updateUserRes: 'Der Benutzer wurde aktualisiert.',
        updateUserEx: 'Fehler beim Aktualisieren des Benutzers',
        createUserRes: 'Der Benutzer wurde erfolgreich angelegt.',
        createUserEx: 'Fehler beim Erstellen der Rolle',
        deleteUserRes: 'Der Benutzer wurde erfolgreich gelöscht.',
        deleteUserEx: 'Fehler beim Löschen des Benutzers',
        membershipEx: 'Fehler beim Laden der Benutzermitgliedschaft',
        addToOrgRes:
            'Der Benutzer wurde erfolgreich zur Organisation hinzugefügt.',
        addToOrgEx: 'Fehler beim Hinzufügen eines Benutzers zur Organisation',
        sendInvitationRes:
            'Einladung wurde erfolgreich an den Benutzer gesendet',
        sendInvitationEx:
            'Beim Senden der Einladung ist ein Fehler aufgetreten',
        deleteRoleRes: 'Die Rolle wurde erfolgreich gelöscht',
        deleteRoleEx: 'Beim Löschen der Rolle ist ein Fehler aufgetreten',
        /* sharing */
        revokeSharingRes: 'Der Zugriff wurde erfolgreich entzogen.',
        revokeSharingEx: 'Fehler beim Entzug des Zugriffs',
        getSharingDataEx: 'Fehler beim Laden der Freigabekomponente',
        shareEx: 'Fehler beim Teilen',
        /* api-keys */
        getApiKeysEx: 'Fehler beim Laden der API-Schlüssel',
        createApiKeyRes: 'Der API-Schlüssel wurde erfolgreich erstellt.',
        createApiKeyEx: 'Fehler beim Erstellen des API-Schlüssels',
        deleteApiKeyRes: 'Der API-Schlüssel wurde erfolgreich gelöscht.',
        deleteApiKeyEx: 'Fehler beim Löschen des API-Schlüssels',
        getApiKeyEx: 'Fehler beim Laden von API-Schlüssel',
        /* register */
        registerUserRes: 'Der Benutzer wurde erfolgreich angelegt.',
        registerUserEx: 'Fehler beim Erstellen des Benutzers',
        registerCustomerRes: 'Die Organisation wurde erfolgreich erstellt.',
        pleaseUseEmail:
            'Bitte verwenden Sie E-Mail-Adresse und Passwort des neuen Benutzers.',
        registerCustomerEx: 'Fehler beim Erstellen der Organisation',
        /* detached sharing */
        getDetachedSharingDataEx: 'Fehler beim Laden der Freigabekomponente',
        shareDetachedSharingDataRes: 'Erfolgreich geteilt',
        shareDetachedSharingDataEx: 'Fehler beim Teilen',
        tomMakeReport: 'Fehler beim Erstellen eines Reports',
        getTomPicturesEx: 'Fehler beim Laden von TOM-Bildern',
        mailSendRes: 'Email wurde erfolgreich versendet',
        mailSendEx: 'Email konnte nicht gesendet werden',
        organisationPhoneEx:
            'Die Telefonnummer der Organisation konnte nicht gespeichert werden',
        commentDeleteRes: 'Kommentar erfolgreich gelöscht',
        commentDeleteEx:
            'Beim Löschen des Kommentars ist ein Fehler aufgetreten',
        commentAddRes: 'Kommentar erfolgreich hinzugefügt',
        commentAddEx:
            'Beim Hinzufügen des Kommentars ist ein Fehler aufgetreten',
        commentEditRes: 'Kommentar erfolgreich bearbeitet',
        commentEditEx:
            'Beim Bearbeiten des Kommentars ist ein Fehler aufgetreten',
        getCommentsEx: 'Beim Laden von Kommentaren ist ein Fehler aufgetreten',
        deviceImagesAddRes: 'Erfolgreich hinzugefügt',
        deviceImagesAddEx: 'Beim Hinzufügen ist ein Fehler aufgetreten',
        deviceImagesEditRes: 'Erfolgreich editiert',
        deviceImagesEditEx: 'Bei der Bearbeitung ist ein Fehler aufgetreten',
        getDeviceImagesEx: 'Beim Laden ist ein Fehler aufgetreten',
        getLocationsByCustomerIdEx:
            'An error occurred while loading locations by customer id',
        getEscalationLevelEx:
            'Beim Laden der Eskalationsstufen ist ein Fehler aufgetreten',
        postEscalationLevelEx:
            'Beim Erstellen von Eskalationsstufen ist ein Fehler aufgetreten',
        postEscalationLevelRes: 'Eskalationsstufen erfolgreich hinzugefügt',
        getDeviceHistoryEx:
            'Beim Laden des Geräteverlaufs ist ein Fehler aufgetreten',
        getUserPreferencesByTypeEx: 'Fehler beim Laden der Benutzervorlieben',
        patchUserPreferencesEx:
            'Fehler beim Aktualisieren der Benutzervorlieben',
        postUserPreferencesEx: 'Fehler beim Erstellen der Benutzervorlieben',
        exportFileEx: 'Fehler beim Exportieren der Datei',
        getSimCardEx: 'Beim Laden der SIM-Karte ist ein Fehler aufgetreten',
        updateSimCardRes: 'SIM-Karte wurde erfolgreich aktualisiert',
        updateSimCardEx:
            'Beim Aktualisieren der SIM-Karte ist ein Fehler aufgetreten',
        createSimCardRes: 'SIM-Karte wurde erfolgreich erstellt',
        createSimCardEx:
            'Beim Erstellen der SIM-Karte ist ein Fehler aufgetreten'
    },
    common: {
        maintenanceMode: 'Wartungsmodus',
        maintenanceDurationCustom: 'Benutzerdefiniert',
        maintenanceDurationMinUnit: 'Min.',
        maintenanceDurationPositiveOnly:
            'Nur positive ganze Zahlen sind erlaubt',
        maintenanceDurationDecrease: 'Minuten verringern',
        maintenanceDurationIncrease: 'Minuten erhöhen',
        maintenanceDurationMinutes: 'Wartungsminuten',
        exitingMMode: 'Wartungsmodus wird beendet',
        switchOnMMode: 'Wartungsmodus einschalten',
        switchOffMMode: 'Wartungsmodus ausschalten',
        switchOnMModeDescr:
            'Im Wartungsmodus werden keine Berichte erstellt und keine Benachrichtigungen gesendet.',
        switchOffMModeDescr: 'Der Wartungsmodus wird ausgeschaltet.',
        ok: 'Ok',
        name: 'Name',
        save: 'Speichern',
        search: 'Suchen',
        cancel: 'Abbrechen',
        submit: 'Bestätigen',
        clear: 'Filter zurücksetzen',
        phone: 'Handynummer',
        organisationPhone: 'Telefonnummer der Organisation',
        email: 'E-Mail',
        organisation: 'Organisation',
        role: 'Rolle',
        password: 'Passwort',
        passwordConfirmation: 'Passwort bestätigen',
        changePassword: 'Passwort ändern',
        oldPassword: 'Altes Passwort',
        newPassword: 'Neues Passwort',
        newPasswordConfiramtion: 'Neues Passwort bestätigen',
        errorContactSupport:
            'Es ist ein Fehler aufgetreten, bitte kontaktieren Sie den Support.',
        revoke: 'Widerrufen',
        share: 'Teilen',
        delete: 'Löschen',
        back: 'Zurück',
        next: 'Weiter',
        confirm: 'Bestätigen',
        skip: 'Überspringen',
        description: 'Beschreibung',
        trap: 'Falle',
        fourHours: '4 Stunden',
        sixHours: '6 Stunden',
        twelveHours: '12 Stunden',
        eighteenHours: '18 Stunden',
        twentyFourHours: '24 Stunden',
        acceptTerms: 'Akzeptieren',
        loading: 'Laden',
        copied: 'Kopiert',
        failedToCopy: 'Fehler beim Kopieren',
        refresh: 'Aktualisieren',
        confirmationCode: 'Sicherheitscode',
        passwordLength: 'Das Passwort hat mehr als 8 Zeichen.',
        passwordSpecialChar: 'Das Passwort enthält Sonderzeichen.',
        passwordNumber: 'Das Passwort hat eine Nummer.',
        passwordCapital: 'Das Passwort hat einen Großbuchstaben.',
        passwordLetter: 'Das Passwort hat einen Buchstaben.',
        nothingWasFound: 'Es wurde nichts gefunden',
        update: 'Aktualisieren',
        newVersionIsAvailable: 'Neue Web App Version verfügbar!',
        pleaseClickUpdate:
            'Bitte drücken Sie rechts auf "Aktualisieren" um die die Anwendung zu aktualisieren. Danach sind wir startklar!',
        required: 'Pflichtfeld',
        passwordErrorMessage: 'Das Passwort ist nicht stark',
        notValidEmail: 'Ungültige E-Mail',
        assigned: 'Zugewiesen',
        assignment: 'Zuweisung',
        done: 'Fertig',
        settings: 'Einstellungen',
        accountSettings: 'Kontoeinstellungen',
        organisationSettings: 'Organisation Einstellungen',
        exportCsv: 'CSV-Export',
        exportExcel: 'Excel-Export',
        exportPdf: 'PDF-Export',
        exportQrPdf: 'Exportieren mit QR-Code',
        createNew: 'Neu erstellen',
        fileTooBig: 'Die Datei ist zu groß',
        emailTo: 'An',
        emailCc: 'Cc',
        advancedInformation: 'Erweiterte Informationen',
        supportChat: 'Support-Chat',
        account: 'Konto',
        manual: 'Anleitungen',
        support: 'Support',
        about: 'Über',
        online: 'Online',
        offline: 'Offline',
        disconnected: 'Getrennt',
        notFilterable: 'Nicht filterbar',
        expandTreeNodes: 'Alle Standorte erweitern',
        collapseTreeNodes: 'Alle Knoten einklappen',
        applyFilters: 'Filter anwenden',
        close: 'Schließen Sie',
        login: 'Anmelden',
        installation: 'Einrichtung',
        success: 'Erfolg'
    },
    tom: {
        openTomBtnTitle: 'Neue Bilder zur Überprüfung',
        loadMore: 'Mehr laden',
        contentType: 'Inhalt typ',
        reportType: 'Meldung',
        createdAt: 'Erstellt',
        updatedAt: 'Aktualisiert',
        status: 'Status',
        bedbug: 'Wanze',
        ant: 'Ameise',
        roach: 'Schabe',
        moth: 'Motte',
        cockroach: 'Kakerlake',
        fly: 'Insekten',
        other: 'Andere',
        mouse: 'Maus',
        rat: 'Ratte',
        activated: 'Aktiviert',
        activity: 'Aktivität',
        falseTrigger: 'Fehlauslösung',
        reviseReport: 'Die Meldung überarbeiten',
        openTom: 'TOM öffnen',
        user_processed: 'Vom Nutzer bewertet',
        not_processed: 'Nicht verarbeitet',
        ai_processed: 'Von KI verarbeitet',
        ai_and_user_processed: 'Von KI verarbeitet und vom Nutzer bewertet',
        tomMode: 'Betriebsmodus',
        period: 'Zeitraum',
        pileEmpty: 'Ihr stapel ist leer.',
        allProcessed: 'Sie haben alle neuen bilder erfolgreich bewertet.',
        deviceName: 'Gerät',
        companyName: 'Organization',
        dateTime: 'Datum',
        operationMode: 'Betriebsmodus',
        ok: 'Ok',
        warning: 'Warnung',
        critical: 'Kritisch',
        comments: 'Kommentare',
        aiProcessed: 'Von KI verarbeitet',
        userProcessed: 'Vom Nutzer bewertet',
        location: 'Standort',
        system: 'System',
        noDevicePictures: 'Noch keine Bilder',
        noPictures: 'Noch keine TOM Bilder',
        notUsingTom: 'Sie nutzen unser neues Produkt “TOM” noch nicht?',
        discoverTom: 'TOM kennen lernen',
        reportedBy: 'Gemeldet von',
        amount: 'Anzahl',
        makeReport: 'Meldung machen',
        relevantPictures: 'Relevante Bilder',
        allPictures: 'Alle Bilder'
    },
    mobileAppScreen: {
        title: 'Wir sind gerade dabei, unsere Web App für mobile Geräte zu optimieren.',
        subtitle:
            'Für ein optimales Nutzererlebnis laden Sie bitte unsere App im App Store oder Google Play Store herunter.'
    },
    addressForm: {
        firstName: 'Vorname',
        lastName: 'Nachname',
        company: 'Firma',
        streetAndNumber: 'Straße & Hausnummer',
        zip: 'PLZ',
        city: 'Stadt',
        country: 'Land',
        note: 'Notiz',
        companyNameRequireValidationMessage: 'Firmenname ist erforderlich',
        companyNameMinLengthValidationMessage: 'Firmenname ist zu kurz',
        companyNameMaxLengthValidationMessage: 'Firmenname ist zu lang',
        companyIsValidValidationMessage: 'Ungültiger Firmenname',
        nameRequireValidationMessage: 'Vorname ist erforderlich',
        nameMinLengthValidationMessage: 'Vorname ist zu kurz',
        nameMaxLengthValidationMessage: 'Vorname ist zu lang',
        nameIsValidValidationMessage: 'Ungültiger Vorname',
        lastNameRequireValidationMessage: 'Nachname ist erforderlich',
        lastNameMinLengthValidationMessage: 'Nachname ist zu kurz',
        lastNameMaxLengthValidationMessage: 'Nachname ist zu lang',
        lastNameIsValidValidationMessage: 'Ungültiger Nachname',
        addressRequireValidationMessage:
            'Straße & Hausnummer sind erforderlich',
        addressIsValidValidationMessage:
            'Ungültiges Format für Straße & Hausnummer',
        zipCodeRequireValidationMessage: 'PLZ ist erforderlich',
        zipCodeIsValidValidationMessage: 'Ungültige PLZ',
        cityRequireValidationMessage: 'Stadt ist erforderlich',
        cityIsValidValidationMessage: 'Ungültige Stadt',
        countryRequireValidationMessage: 'Land ist erforderlich',
        countryIsValidValidationMessage: 'Ungültiger Ländername'
    },
    billing: {
        billing: 'Abrechnung',
        externalUsersCreationNotice:
            'Neue externe Benutzer, die nach dem 01.01.2025 erstellt werden, werden monatlich mit jeweils 2,50 € netto berechnet. Eine Übersicht Ihrer monatlichen Abonnements finden Sie im Abrechnungs-Dashboard.',
        escalationLevelsCreationNotice:
            'Neue E-Mail-Adressen, die nach dem 01.01.2025 für Eskalationsstufen zugewiesen werden, werden monatlich mit jeweils 2,50 € netto berechnet. Eine Übersicht Ihrer monatlichen Abonnements finden Sie im Abrechnungs-Dashboard.',
        billingDashboard: 'Abrechnungs-Dashboard',
        lastHeartbeat: 'Letzter Heartbeat',
        removedAt: 'Entfernt am',
        externalUsers: 'Externe Benutzer',
        amount: 'Anzahl',
        apiDevices: 'Geräte-API',
        monetisation: 'Monetarisierung',
        itCanUpToAMinute: 'Es kann bis zu einer Minute dauern',
        currentMonth: 'Aktueller Monat'
    }
}

export default de
